<!-- Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein. -->
<style scoped>
    .osfQuizExternalUrl {
       position: relative;
        height: 30rem;
        text-align: center;
        border: solid 0.0625rem #5f4c54;
        width: 100%;
        box-sizing: border-box;
    }
</style>
<template>
    <div>
        <div class="osfQuizExternalUrl">
            <iframe
                :src="externalUrl"
                width="100%"
                height="100%"
                frameborder="0"
            />
        </div>
    </div>
</template>

<script>
export default {
    name: 'ExternalUrl',
    computed: {
        externalUrl: {
            get() {
                return this.$store.state.externalUrl;
            }
        }
    }
};
</script>
